export default __webpack_public_path__ + "static/media/Team.7b558e38.svg";